import config from "../../../../config.json" with { type: "json" };

export interface Credentials {
	login: string;
	password: string;
}

type TKey = keyof typeof config;

const getSettings = <T>(key: string, defaultValue: T): T => {
	if (!key) {
		console.warn("Key is required to get an config variable");
		return defaultValue;
	}

	return (config[key as TKey] as T) !== undefined
		? (config[key as TKey] as T)
		: defaultValue;
};

export const settings = {
	apiHost: getSettings("apiHost", ""),
	wsHost: getSettings("wsHost", ""),
	authUrl: getSettings("authUrl", ""),
	oauthClientId: getSettings("oauthClientId", ""),
	infiniteTableLicenseKey: getSettings("infiniteTableLicenseKey", ""),
	streamChatApiKey: getSettings("streamChatApiKey", ""),
	streamChatChannelId: getSettings("streamChatChannelId", ""),
	sentryDsn: getSettings("sentryDsn", ""),
	features: getSettings("features", {}),
	pricingTableId: getSettings("pricingTableId", ""),
	pricingTablePublishableKey: getSettings("pricingTablePublishableKey", ""),
	baseBillingUrl: getSettings("baseBillingUrl", ""),
	allowRobots: getSettings("allowRobots", false),
	landingPageUrl: getSettings("landingPageUrl", ""),
	ta: getSettings<{
		appUrl: string;
		free?: Credentials;
		silver?: Credentials;
		gold?: Credentials;
		platinum?: Credentials;
	}>("ta", { appUrl: "http://localhost:5173" }),
};

export type Settings = typeof settings;
